import Feature from 'ol/Feature';
import Map from 'ol/Map';
import { Point } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import { transform } from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import { Icon, Style } from 'ol/style';
import { useEffect } from 'react';

export const useDrawCrosshair = (
  latitude: number | null,
  longitude: number | null,
  map: Map
) => {
  useEffect(() => {
    if (latitude === null || longitude === null) {
      return;
    }

    const zoom = map.getView().getZoom();

    // Zoom level 15 is where we draw the ships based on their true dimensions,
    //  which causes the crosshair to be drawn at the wrong position CLASSIC 8282
    if (!zoom || zoom >= 15) {
      return;
    }

    const squareSvgIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <line x1="0" y1="0" x2="5" y2="0" style="stroke: white; stroke-width: 4;" />
      <line x1="0" y1="0" x2="0" y2="5" style="stroke: white; stroke-width: 4;" />
      <line x1="20" y1="0" x2="15" y2="0" style="stroke: white; stroke-width: 4;" />
      <line x1="20" y1="0" x2="20" y2="5" style="stroke: white; stroke-width: 4;" />
      <line x1="0" y1="20" x2="5" y2="20" style="stroke: white; stroke-width: 4;" />
      <line x1="0" y1="20" x2="0" y2="15" style="stroke: white; stroke-width: 4;" />
      <line x1="20" y1="20" x2="15" y2="20" style="stroke: white; stroke-width: 4;" />
      <line x1="20" y1="20" x2="20" y2="15" style="stroke: white; stroke-width: 4;" />
    </svg>`;

    // Create source and layer for the crosshair marker
    const crosshairSource = new VectorSource();
    const crosshairLayer = new VectorLayer({
      source: crosshairSource,
      style: new Style({
        image: new Icon({
          src: 'data:image/svg+xml;utf8,' + encodeURIComponent(squareSvgIcon),
          anchor: [0.5, 0.5], // Center the icon
        }),
      }),
    });

    // Add the crosshair layer to the map
    map.addLayer(crosshairLayer);

    // Function to draw a crosshair at a specific latitude and longitude
    const drawCrosshair = (latitude: number, longitude: number) => {
      // Convert latitude and longitude to map projection (e.g. EPSG:3857)
      const coordinate = transform(
        [longitude, latitude],
        'EPSG:4326',
        'EPSG:3857'
      );

      // Clear any previously drawn crosshairs
      crosshairSource.clear();

      // Create a crosshair and add it to the crosshair source
      const crosshair = new Feature({
        geometry: new Point(coordinate),
      });
      crosshairSource.addFeature(crosshair);
    };

    drawCrosshair(latitude, longitude);

    return () => {
      map.removeLayer(crosshairLayer);
    };
  }, [map, latitude, longitude]);
};
